import clsx from "clsx";
import { ComponentProps } from "react";

export type NavbarContentCenterProps = ComponentProps<"div">;
export const NavbarContentCenter = ({ children, className }: NavbarContentCenterProps) => {
  return (
    <div
      data-testid="navbar-content-center"
      className={clsx(
        "flex flex-1 shrink px-2 justify-center items-center *:w-full [&>*>*]:w-full [&>*>*]:flex [&>*>*]:justify-center overflow-hidden",
        className
      )}
    >
      {children}
    </div>
  );
};
